<template>
  <modal
    name="feedback-message"
    class="feedback-message-modal"
    classes="rounded-0"
    :width="360"
    height="100%"
    :shift-x="1.0"
    :shift-y="0"
    overlay-transition="none"
    @before-open="onBeforeOpen"
    @before-close="onBeforeClose"
  >
    <vuescroll>
      <div class="feedback-message-modal__content">
        <close-btn
          class="feedback-message-modal__close"
          position="custom"
          @click="$modal.hide('feedback-message')"
        />

        <div v-if="isForm" class="feedback-message-modal__body">
          <h3 class="feedback-message-modal__title">Обратная связь</h3>
          <feedback-message-form @success="isForm = false" />
        </div>
        <template v-else>
          <div class="feedback-message-modal__body">
            <p class="feedback-message-modal__message">
              Спасибо, Ваше сообщение отправлено!
            </p>
          </div>
          <div class="feedback-message-modal__footer">
            <base-btn
              display="block"
              view="secondary"
              size="sm"
              @click="$modal.hide('feedback-message')"
              >Закрыть</base-btn
            >
          </div>
        </template>
      </div>
    </vuescroll>
  </modal>
</template>

<script>
import CloseBtn from "@/components/shared/CloseBtn";
import BaseBtn from "@/components/shared/BaseBtn";
import FeedbackMessageForm from "./FeedbackMessageForm";
import vuescroll from "vuescroll";
// utils
import { mapActions } from "vuex";

export default {
  components: {
    CloseBtn,
    BaseBtn,
    FeedbackMessageForm,
    vuescroll,
  },
  data() {
    return {
      isForm: true,
    };
  },
  methods: {
    ...mapActions("settings", {
      setSettings: "onSetSettings",
    }),
    onBeforeOpen() {
      this.isForm = true;

      this.setSettings({ key: "isModal", value: true });
    },
    onBeforeClose() {
      this.setSettings({ key: "isModal", value: false });
    },
  },
};
</script>

<style lang="scss" scoped>
.feedback-message-modal {
  &__close {
    right: 9px;
    top: 9px;
  }

  &__content {
    background-clip: padding-box;
    background-color: $white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 100vh;
    outline: 0;
    padding: 32px 28px 4rem;
    pointer-events: auto;
    position: relative;
    width: 100%;
  }

  &__body {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    height: 100%;
    justify-content: center;
  }

  &__title {
    margin-bottom: 48px;
    text-align: center;
  }

  &__message {
    @extend %subtitle;
    color: $primary;
    text-align: center;
  }
}
</style>
